export default "__VITE_ASSET__1b24ef3e__"